var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPixIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4812 17.4409C22.6925 17.2296 23.0562 17.2296 23.2674 17.4409L26.2792 20.4526C26.8346 21.0081 27.5739 21.3132 28.3562 21.3132H28.9468L25.1488 25.1111C23.9637 26.265 22.0393 26.265 20.8541 25.1111L17.0405 21.3014H17.4042C18.1865 21.3014 18.9258 20.9963 19.4812 20.4409L22.4812 17.4409ZM23.2674 14.5621C23.0171 14.7772 22.6964 14.7811 22.4812 14.5621L19.4812 11.562C18.9258 10.9714 18.1865 10.7015 17.4042 10.7015H17.0405L20.8502 6.89022C22.0393 5.70326 23.9637 5.70326 25.1488 6.89022L28.9507 10.6898H28.3562C27.5739 10.6898 26.8346 10.9949 26.2792 11.5503L23.2674 14.5621ZM17.4042 11.5816C17.944 11.5816 18.4408 11.8006 18.8554 12.1839L21.8554 15.184C22.137 15.4304 22.5047 15.6064 22.8763 15.6064C23.244 15.6064 23.6116 15.4304 23.8933 15.184L26.905 12.1722C27.2884 11.7928 27.8164 11.5737 28.3562 11.5737H29.8308L32.1111 13.8541C33.2963 15.0392 33.2963 16.9637 32.1111 18.1488L29.8308 20.4292H28.3562C27.8164 20.4292 27.2884 20.2101 26.905 19.8268L23.8933 16.815C23.3496 16.2713 22.3991 16.2713 21.8554 16.8189L18.8554 19.8151C18.4408 20.1984 17.944 20.4174 17.4042 20.4174H16.1596L13.8902 18.1488C12.7033 16.9637 12.7033 15.0392 13.8902 13.8541L16.1596 11.5816H17.4042Z",
    fill: "#221E16"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    stroke: "#44413B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixIcon);
export default __webpack_public_path__ + "static/media/pix-icon.c99197c26ca8aedb185a5e1867009679.svg";
export { ForwardRef as ReactComponent };